export enum PartnerReportModeType {
    All = 'ALL',
    SharedOnly = 'SHARED_ONLY',
    SubscriptionOnly = 'SUBSCRIPTION_ONLY'
}
